<!-- Copyright (C) Siemens AG 2026. All rights reserved. -->

<router-outlet></router-outlet>
